import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Signup API integration
// export const signupUser = createAsyncThunk('auth/signup', async (data) => {
//   try {
//     const res = await axios({
//       method: 'POST',
//       url: process.env.REACT_APP_API_URL + 'sign_up',
//       data: {
//         "name": data?.values?.name,
//         "email": data?.values?.email,
//         "phone": data?.values?.phone,
//         "password": data?.values?.password
//       },
//       headers: { "Content-Type": "application/json" }
//     });
//     return res;
//   } catch (error) {
//     return error.response;
//   }
// });

// OTP Verification API integration
export const verifyOtp = createAsyncThunk('auth/verifyOtp', async (data) => {
  try {
    const res = await axios({
      method: 'POST',
      url: process.env.REACT_APP_API_URL + 'otp_verify',
      data: {
        "email": data?.email,
        "otp": data?.otp
      },
      headers: { "Content-Type": "application/json" }
    });
    return res;
  } catch (error) {
    return error.response;
  }
});


// export const login = createAsyncThunk('auth/login', async (data) => {
//   try {
//     const res = await axios({
//       method: 'POST',
//       url: process.env.REACT_APP_API_URL + 'sign_in',
//       data: {
//         "email": data?.values?.email,
//         "password": data?.values?.password
//       },
//       headers: { "Content-Type": "application/json" }
//     });
//     return res;
//   } catch (error) {
//     return error.response;
//   }
// });

const initialState = {
  user: null,
  isAuthenticated: false,
  loading: false,
  error: null,
  signupData: null,
  loginData: null,
  loginData: null,
  otpSent: false,
  otpVerified: false,
  signupStep: 'form', // 'form', 'otp', 'success'
  apiResponse: null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetSignup: (state) => {
      state.signupData = null;
      state.loginData = null;
      state.otpSent = false;
      state.otpVerified = false;
      state.signupStep = 'form';
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    // Handle signup API
    // builder.addCase(signupUser.pending, (state) => {
    //   state.loading = true;
    //   state.error = null;
    // });
    // builder.addCase(signupUser.fulfilled, (state, action) => {
    //   state.loading = false;
    //   const httpOk = action?.payload?.status === 200 || action?.payload?.status === 201;
    //   const apiOk = action?.payload?.data?.status === true;
    //   const messageText = action?.payload?.data?.message?.toLowerCase?.() || '';
    //   const isUserExists = messageText.includes('user already exists');

    //   if (httpOk && apiOk) {
    //     console.log(action.payload.data)
    //     state.signupData = action.payload.data;
    //     state.loginData = action.payload.data;
    //     state.otpSent = true;
    //     state.signupStep = 'otp';
    //     state.apiResponse = action.payload;
    //   } else if (isUserExists) {
    //     // Keep on signup form; external handler will redirect to login
    //     state.otpSent = false;
    //     state.signupStep = 'form';
    //     state.apiResponse = action.payload;
    //   } else {
    //     state.error = action.payload?.data?.message || 'Signup failed';
    //   }
    // });
    // builder.addCase(signupUser.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = 'Network error occurred';
    // });

    // Handle OTP verification API
    builder.addCase(verifyOtp.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(verifyOtp.fulfilled, (state, action) => {
      state.loading = false;
      const httpOk = action?.payload?.status === 200 || action?.payload?.status === 201;
      const apiOk = action?.payload?.data?.status === true;
      if (httpOk && apiOk) {
        state.otpVerified = true;
        state.isAuthenticated = true;
        state.user = action.payload.data;
        state.signupStep = 'success';
        state.apiResponse = action.payload;
      } else {
        // Keep user on OTP step when API signals failure (e.g., OTP expired)
        state.signupStep = 'otp';
        state.error = action.payload?.data?.message || 'OTP verification failed';
      }
    });
    builder.addCase(verifyOtp.rejected, (state, action) => {
      state.loading = false;
      state.error = 'Network error occurred';
    });
  }
});

export const { resetSignup, clearError } = authSlice.actions;

export default authSlice.reducer;